module.exports = __webpack_public_path__ + "img/info-file.44d5c74e.svg";